export default __webpack_public_path__ + "static/media/sac-logo.7776b610.svg";